import fetch from '@/utils/fetch';

// 新增留言记录
export function addTrainRecord(args) {

    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'common/throughTrain/addTrainRecord',
        method: 'post',
        data: JSON.stringify(args)
    });
}


// 根据学校id查询类型列表
export function getTrainTypeListBySchoolId(args) {
    let params = new URLSearchParams();
    params.append('schoolId', args.schoolId);

    return fetch({
        url: 'common/throughTrain/getTrainTypeListBySchoolId',
        method: 'get',
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/outer/outer.js